<span *ngIf="buyEnabled" nz-tooltip nzTooltipTitle="{{ 'buy' | translate}} {{ product | translate}}">
	<img [src]="buyIcon" class="btn-buy mr-2 pointer" 	(click)="buy()">
</span>
<span *ngIf="watchlistEnabled" nz-tooltip nzTooltipTitle="{{ 'add.to.watchlist' | translate}}">
	<img [src]="watchlist" class="mr-2 pointer" (click)="addToWatchList()">
</span>